var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { BsPencil } from 'react-icons/bs';
import { FaRegClone } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';
import { RiArrowDownLine, RiArrowUpDownLine, RiArrowUpLine } from 'react-icons/ri';
import { Spring } from 'react-spring/renderprops';
import { useLanguage } from '@base/LanguageProvider';
import { WidgetType } from '@common/api';
import WidgetLoader from '@main/dashboard/WidgetLoader';
import WidgetMenu from '@main/dashboard/WidgetMenu';
import WidgetParentChangeModal from '@main/dashboard/WidgetParentChangeModal';
import { Copy, Delete, Download, Edit, Materialize, Plus, Select } from '@shared/icons/icons';
import Manager from '@shared/modal/Manager';
import { useAuth } from '../../../providers/AuthProvider';
import useKPIData from '@data/hooks/kpiData';
import { useTagContext } from '@data/tag/tagContext';
import { useCloneWidget, useDeleteWidget, useGetKPIColumnsFromSlicer, useUpdateWidget, useWidgets, } from '@data/widgets/widgetActions';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { ConditionalFormatting, ConditionalFormattingType, ConditionalFormattingValueType, KpiColumnOperation, KpiColumnType, KpiLineFormat, } from '@util/enums';
import { formatNumber, formatNumberKPI } from '@util/formatNum';
import { genUniqueId } from '@util/helpers';
import { Arrows, ColorScale, ColorScaleInner, DataBar, DataBarInner, Grid, GridCol, GridColFixedLeft, GridContainer, GridItem, GridItemHeader, KPIColHeader, KPIColHeaderBtn, KPIColHeaderBtns, KPIColHeaderSubitle, KPIColHeaderTitle, KPIColInfoLabel, KPIHeaderResizer, KPIRowCell, KPIRowTitle, TrafficLights, TrafficLightsInner, } from '@styled/KPI';
import { appColors } from '@styled/useTheme';
import { WidgetBox, WidgetContent, WidgetTitle } from '@styled/Widget';
import { getAccountTagFormat } from '../../../data/cell/cell';
import { createSheetRowName, SheetRowPath } from '../../../data/sheetRow/sheetRow';
import { useSheetRowBranch, useSheetRowsById } from '../../../data/sheetRow/sheetRowHooks';
import { isExcelDateFormat } from '../../../util/number';
import ColumnEditModal from './KPIColumnEditor';
import KPIEditor from './KPIEditor';
import ExportKPIOptionsModal from '../../../features/export/ExportKPIOptionsModal';
var KPI = function (_a) {
    var e_1, _b;
    var _c, _d, _e, _f;
    var gridId = _a.gridId, widget = _a.widget, documentActions = _a.documentActions, tagSlicersData = _a.tagSlicersData;
    var wrapperRef = useRef(null);
    var user = useAuth().user;
    var L = useLanguage().L;
    var _g = useTagContext(), tagData = _g.tagData, tagsLoading = _g.tagsLoading;
    var allWidgets = (_c = useWidgets().data) !== null && _c !== void 0 ? _c : [];
    var updateWidget = useUpdateWidget();
    var cloneWidget = useCloneWidget();
    var deleteWidget = useDeleteWidget();
    var getKPIColumnsFromSlicer = useGetKPIColumnsFromSlicer();
    var sheetRowsById = useSheetRowsById();
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widget.config, WidgetType.KPI); }, [widget.config]);
    var uncollapsed = widgetConfig.uncollapsed;
    var sheetRowPath = new SheetRowPath(widgetConfig.path);
    var kpiRows = [];
    var expanded = __spreadArray([widgetConfig.path], __read(uncollapsed), false);
    var _h = __read(useSheetRowBranch(sheetRowPath, tagData.tagById, sheetRowsById, expanded), 2), sheetRows = _h[0], isLoadingRows = _h[1];
    try {
        for (var sheetRows_1 = __values(sheetRows), sheetRows_1_1 = sheetRows_1.next(); !sheetRows_1_1.done; sheetRows_1_1 = sheetRows_1.next()) {
            var sheetRow = sheetRows_1_1.value;
            var path = new SheetRowPath(sheetRow.path);
            var parentPath = (_f = (_e = (_d = path.segments) === null || _d === void 0 ? void 0 : _d[path.segments.length - 2]) === null || _e === void 0 ? void 0 : _e.fullPath) !== null && _f !== void 0 ? _f : '0';
            //skip the root
            if (sheetRow.depth === 0) {
                continue;
            }
            kpiRows.push({
                objectId: sheetRow.path,
                ParentId: parentPath,
                title: createSheetRowName(sheetRow, { display: widgetConfig.rowNameDisplay }),
                //adjust for the skiped root row
                depth: sheetRow.depth - 1,
                isParent: sheetRow.hasChildren,
                hasAccountTags: !!sheetRow.variable,
                tags: sheetRow.allTags.map(function (t) { return t.id; }),
                usedTagId: sheetRow.generatedTagId,
                isFake: !!sheetRow.generatedTag,
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (sheetRows_1_1 && !sheetRows_1_1.done && (_b = sheetRows_1.return)) _b.call(sheetRows_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var targetKpiCols = useMemo(function () {
        if (widgetConfig.sharedColumnConfigWidgetId !== null) {
            var targetKpi = allWidgets.find(function (w) { return w.id === widgetConfig.sharedColumnConfigWidgetId; });
            if (targetKpi !== undefined && targetKpi.type === WidgetType.KPI) {
                return parseWidgetConfig(targetKpi.config, WidgetType.KPI).kpiCols;
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    }, [widgetConfig.sharedColumnConfigWidgetId, allWidgets]);
    var kpiColsFromSlicer = useMemo(function () {
        if (widgetConfig.useSlicerData) {
            return getKPIColumnsFromSlicer(widget.GridId, tagData.internalTagsMap);
        }
        else {
            return [];
        }
    }, [widgetConfig.useSlicerData, widget.GridId, tagData.internalTagsMap, getKPIColumnsFromSlicer]);
    var kpiColumns = useMemo(function () {
        if (widgetConfig.sharedColumnConfigWidgetId !== null) {
            return targetKpiCols;
        }
        if (widgetConfig.useSlicerData) {
            return kpiColsFromSlicer;
        }
        return widgetConfig.kpiCols;
    }, [widgetConfig.sharedColumnConfigWidgetId, widgetConfig.useSlicerData, targetKpiCols, kpiColsFromSlicer]);
    var _j = useKPIData(kpiColumns, kpiRows, widgetConfig, widget.id, tagData.tagById, tagSlicersData.activeTagIds), rows = _j.rows, cols = _j.cols;
    var saveKPIColumns = function (newCols) { return __awaiter(void 0, void 0, void 0, function () {
        var newConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newConfig = JSON.stringify(__assign(__assign({}, widgetConfig), { kpiCols: newCols }));
                    return [4 /*yield*/, updateWidget.mutateAsync(__assign(__assign({}, widget), { config: newConfig }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var addColumn = function (column) {
        var usedIds = kpiColumns.map(function (c) { var _a; return (_a = c.id) !== null && _a !== void 0 ? _a : ''; });
        saveKPIColumns(__spreadArray(__spreadArray([], __read(kpiColumns), false), [__assign(__assign({}, column), { id: genUniqueId(usedIds) })], false));
    };
    var editColumn = function (editedColumn) {
        saveKPIColumns(kpiColumns.map(function (col) {
            if (col.id === editedColumn.id) {
                return editedColumn;
            }
            return col;
        }));
    };
    var cloneColumn = function (columnToClone) {
        if (columnToClone) {
            var payload = __assign({}, columnToClone);
            delete payload.id;
            addColumn(payload);
        }
    };
    var deleteColumn = function (cId) {
        saveKPIColumns(kpiColumns.filter(function (col) { return col.id !== cId; }));
    };
    var addColumnModal = function () {
        Manager.renderModal(React.createElement(ColumnEditModal, { tagById: tagData.tagById, onSave: addColumn, columns: kpiColumns }));
    };
    var materializeSlicerColumns = function () { return __awaiter(void 0, void 0, void 0, function () {
        var kpiCols, newConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    kpiCols = getKPIColumnsFromSlicer(widget.GridId, tagData.internalTagsMap);
                    newConfig = JSON.stringify(__assign(__assign({}, widgetConfig), { useSlicerData: false, kpiCols: kpiCols }));
                    return [4 /*yield*/, updateWidget.mutateAsync(__assign(__assign({}, widget), { config: newConfig }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var editColumnModal = function (column) {
        Manager.renderModal(React.createElement(ColumnEditModal, { item: column, tagById: tagData.tagById, onSave: editColumn, columns: kpiColumns }));
    };
    var collapseChildren = function (objectId) {
        var widgetCopy = __assign({}, widget);
        var uncollapsedCopy = __spreadArray([], __read(uncollapsed), false);
        if (uncollapsed.includes(objectId)) {
            uncollapsedCopy = uncollapsedCopy.filter(function (itemId) { return itemId !== objectId; });
        }
        else {
            uncollapsedCopy.push(objectId);
        }
        var allRowObjectIds = new Set(kpiRows.map(function (r) { return r.objectId; }));
        uncollapsedCopy = uncollapsedCopy.filter(function (itemId) { return allRowObjectIds.has(itemId); });
        widgetConfig.uncollapsed = uncollapsedCopy;
        widgetCopy.config = JSON.stringify(widgetConfig);
        updateWidget.mutate(widgetCopy);
    };
    var uncollapseToLevel = function (level) {
        var widgetCopy = __assign({}, widget);
        var newUncollapsed = [];
        kpiRows.map(function (row) {
            if (row.depth < level) {
                newUncollapsed.push(row.objectId);
            }
        });
        widgetConfig.uncollapsed = newUncollapsed;
        widgetCopy.config = JSON.stringify(widgetConfig);
        updateWidget.mutate(widgetCopy);
    };
    var saveColWidth = function (width) {
        var widgetCopy = __assign({}, widget);
        widgetConfig.colWidth = [width];
        widgetCopy.config = JSON.stringify(widgetConfig);
        updateWidget.mutate(widgetCopy);
    };
    var saveSort = function (sort) {
        var widgetCopy = __assign({}, widget);
        widgetConfig.sort = sort;
        widgetCopy.config = JSON.stringify(widgetConfig);
        updateWidget.mutate(widgetCopy);
    };
    var exportKpi = function (filename) {
        var slicersDimensionIds = Object.entries(tagSlicersData.activeTagIds).reduce(function (ids, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (value.length > 0) {
                ids.push(value);
            }
            return ids;
        }, []);
        Manager.renderModal(React.createElement(ExportKPIOptionsModal, { filename: filename, widgetId: widget.id, slicersDimensionIds: slicersDimensionIds }));
    };
    var widgetMenuItems = [
        {
            icon: Edit,
            actionName: L('Edit Tile'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return Manager.renderModal(React.createElement(KPIEditor, { widget: widget, gridId: gridId })); },
        },
        {
            icon: Copy,
            actionName: L('Duplicate'),
            isDisabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canDuplicate),
            action: function () { return cloneWidget.mutate(widget); },
        },
        {
            icon: Select,
            actionName: L('Move to'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: function () { return Manager.renderModal(React.createElement(WidgetParentChangeModal, { widget: widget, gridId: gridId })); },
        },
        {
            icon: Download,
            actionName: L('Export'),
            action: function () { return exportKpi("".concat(widget.title.length > 0 ? widget.title : 'KPI', ".xlsx")); },
        },
        { spacer: true },
        {
            icon: Delete,
            actionName: L('Delete Tile'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canDelete),
            action: function () { return deleteWidget.mutate(widget.id); },
            destructive: true,
        },
    ];
    if (widgetConfig.useSlicerData) {
        widgetMenuItems.unshift({
            icon: Materialize,
            actionName: L('Materialize'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: materializeSlicerColumns,
            creative: true,
        }, { spacer: true });
    }
    else {
        widgetMenuItems.unshift({
            icon: Plus,
            actionName: L('New Column'),
            isDisabled: !(documentActions === null || documentActions === void 0 ? void 0 : documentActions.canUpdate),
            action: addColumnModal,
            creative: true,
        }, { spacer: true });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(WidgetBox, { className: "tiny-scrollbars only-on-hover", ref: wrapperRef },
            widget.title && widget.title != '' && React.createElement(WidgetTitle, null, widget.title),
            React.createElement(WidgetMenu, { wrapperRef: wrapperRef, menuItems: widgetMenuItems }),
            React.createElement(WidgetContent, null,
                React.createElement(KPITable, { cols: cols, rows: rows, widgetConfig: widgetConfig, editColumn: editColumnModal, cloneColumn: cloneColumn, deleteColumn: deleteColumn, uncollapseToLevel: uncollapseToLevel, collapseChildren: collapseChildren, saveColWidth: saveColWidth, saveSort: saveSort, showColumnActions: widgetConfig.sharedColumnConfigWidgetId === null && !widgetConfig.useSlicerData, columnHoverMessage: widgetConfig.sharedColumnConfigWidgetId !== null
                        ? L('Using shared column config')
                        : widgetConfig.useSlicerData
                            ? L('Slicer generated')
                            : undefined }))),
        React.createElement(WidgetLoader, { wId: widget.id, loading: tagsLoading || isLoadingRows })));
};
function KPITable(_a) {
    var cols = _a.cols, rows = _a.rows, widgetConfig = _a.widgetConfig, editColumn = _a.editColumn, cloneColumn = _a.cloneColumn, deleteColumn = _a.deleteColumn, collapseChildren = _a.collapseChildren, uncollapseToLevel = _a.uncollapseToLevel, saveColWidth = _a.saveColWidth, saveSort = _a.saveSort, showColumnActions = _a.showColumnActions, columnHoverMessage = _a.columnHoverMessage;
    var tagData = useTagContext().tagData;
    var gridRef = useRef(null);
    var _b = __read(useState(0), 2), scrollTo = _b[0], setScrollTo = _b[1];
    var _c = __read(useState(widgetConfig.colWidth[0] ? widgetConfig.colWidth[0] : 300), 2), firstColWidth = _c[0], setFirstColWidth = _c[1];
    var _d = __read(useState(false), 2), dragging = _d[0], setDragging = _d[1];
    useEffect(function () {
        if (rows.length > 0 && gridRef.current && gridRef.current.scrollTop !== scrollTo) {
            var height = gridRef.current.getBoundingClientRect().height;
            var scrollHeight = gridRef.current.scrollHeight;
            var newTop = height + scrollTo > scrollHeight ? scrollHeight - height : scrollTo;
            gridRef.current.scrollTop = newTop;
            setScrollTo(0);
        }
    }, [rows.length]);
    var collapseChildrenHandler = function (objectId) {
        if (gridRef.current) {
            setScrollTo(gridRef.current.scrollTop);
        }
        collapseChildren(objectId);
    };
    var resizeStart = function (e) {
        e.stopPropagation();
        setDragging(true);
    };
    var resizeHandler = function (e) {
        if (dragging && e.movementX !== 0) {
            e.stopPropagation();
            var newWidth = firstColWidth + e.movementX;
            if (newWidth >= 110) {
                setFirstColWidth(firstColWidth + e.movementX);
            }
        }
    };
    var resizeEnd = function (e) {
        if (dragging) {
            e.stopPropagation();
            setDragging(false);
            saveColWidth(firstColWidth);
        }
    };
    var hasSubtitles = cols.some(function (col) { return col.subheader && col.subheader !== ''; });
    return (React.createElement(GridContainer, { onMouseDown: function (e) {
            e.stopPropagation();
        }, onWheel: function (e) {
            e.stopPropagation();
        }, ref: gridRef },
        React.createElement(Grid, { onMouseMove: resizeHandler, onMouseUp: resizeEnd, onMouseLeave: resizeEnd },
            React.createElement(GridColFixedLeft, { "$width": firstColWidth },
                React.createElement(GridItemHeader, null,
                    React.createElement(KPITableUnCollapsers, { hasSubtitles: hasSubtitles, uncollapseToLevel: uncollapseToLevel, resizeStart: resizeStart })),
                rows.map(function (row) {
                    return (React.createElement(GridItem, { key: row.objectId },
                        React.createElement(KPITableTitle, { row: row, collapseChildren: collapseChildrenHandler })));
                })),
            cols.map(function (col, colIdx) {
                return (React.createElement(GridCol, { key: "grid-col-".concat(col.id, "}") },
                    React.createElement(GridItemHeader, null,
                        React.createElement(KPITableHeader, { column: col, editColumn: editColumn, cloneColumn: cloneColumn, deleteColumn: deleteColumn, saveSort: saveSort, showColumnActions: showColumnActions, columnHoverMessage: columnHoverMessage, hasSubtitles: hasSubtitles })),
                    rows.map(function (row) {
                        var cellData = row && row.data && row.data[colIdx] ? row.data[colIdx] : null;
                        return (React.createElement(GridItem, { key: "grid-item-".concat(col.id, "-").concat(row.objectId, "}") },
                            React.createElement(KPITableCell, { cell: cellData, column: col, numformat: widgetConfig.numformat, tagByIdMap: tagData.tagById })));
                    })));
            }))));
}
function KPITableUnCollapsers(_a) {
    var hasSubtitles = _a.hasSubtitles, uncollapseToLevel = _a.uncollapseToLevel, resizeStart = _a.resizeStart;
    return (React.createElement(KPIColHeader, null,
        React.createElement(KPIColHeaderTitle, null),
        hasSubtitles && React.createElement(KPIColHeaderSubitle, null),
        React.createElement(KPIHeaderResizer, { onMouseDown: resizeStart })));
}
function KPITableHeader(_a) {
    var column = _a.column, editColumn = _a.editColumn, cloneColumn = _a.cloneColumn, deleteColumn = _a.deleteColumn, saveSort = _a.saveSort, showColumnActions = _a.showColumnActions, columnHoverMessage = _a.columnHoverMessage, hasSubtitles = _a.hasSubtitles;
    return (React.createElement(KPIColHeader, null,
        React.createElement(KPIColHeaderTitle, null, column.title),
        React.createElement(KPIColHeaderBtns, { className: "kpi-col-header-btns" }, !showColumnActions ? (React.createElement(KPIColInfoLabel, null, columnHoverMessage !== null && columnHoverMessage !== void 0 ? columnHoverMessage : '')) : (React.createElement(React.Fragment, null,
            React.createElement(KPIColHeaderBtn, { onClick: function () { return cloneColumn(column); } },
                React.createElement(FaRegClone, null)),
            React.createElement(KPIColHeaderBtn, { onClick: function () { return editColumn(column); } },
                React.createElement(BsPencil, null)),
            React.createElement(KPIColHeaderBtn, { onClick: function () { return deleteColumn(column.id); } },
                React.createElement(IoMdClose, { fill: "red" })),
            React.createElement(KPIColHeaderBtn, { onClick: function () { return saveSort({ asc: true, colId: column.id }); } },
                React.createElement(RiArrowDownLine, null)),
            React.createElement(KPIColHeaderBtn, { onClick: function () { return saveSort({ asc: false, colId: column.id }); } },
                React.createElement(RiArrowUpLine, null)),
            React.createElement(KPIColHeaderBtn, { onClick: function () { return saveSort(null); } },
                React.createElement(RiArrowUpDownLine, null))))),
        hasSubtitles && React.createElement(KPIColHeaderSubitle, null, column.subheader)));
}
function KPITableTitle(_a) {
    var row = _a.row, collapseChildren = _a.collapseChildren;
    var clickHandler = function () {
        collapseChildren(row.objectId);
    };
    return (React.createElement(KPIRowTitle, { "$depth": row.depth, "$isTableOption": row.tableTagOption !== undefined, onClick: clickHandler },
        React.createElement("div", null, row.title)));
}
function KPITableCell(_a) {
    var cell = _a.cell, column = _a.column, numformat = _a.numformat, tagByIdMap = _a.tagByIdMap;
    var _b = useLanguage(), excelLocalizedNumberFormat = _b.excelLocalizedNumberFormat, excelLocalizedDateFormat = _b.excelLocalizedDateFormat;
    var _c = column.conditionalFormatting, cf = _c === void 0 ? ConditionalFormatting.OFF : _c, _d = column.hideNumbers, hideNumbers = _d === void 0 ? false : _d;
    var padd = cf > 0 && (cf === ConditionalFormatting.TRAFFIC || cf === ConditionalFormatting.ARROWS);
    var accountTagFormat = cell ? getAccountTagFormat(cell, tagByIdMap) : undefined;
    var kpiLineFormat = KpiLineFormat.DEFAULT;
    if (column.type === KpiColumnType.DIFF) {
        if (column.operation === KpiColumnOperation.DIFF_PERCENT ||
            column.operation === KpiColumnOperation.PERCENT ||
            column.operation === KpiColumnOperation.PERCENT_ROUNDED_THOUSANDS) {
            kpiLineFormat = KpiLineFormat.PERCENT_2DECIMALS;
        }
    }
    var formattedValue = '';
    if (cell && cell.value !== null) {
        formattedValue =
            accountTagFormat && kpiLineFormat !== KpiLineFormat.PERCENT_2DECIMALS
                ? isExcelDateFormat(accountTagFormat)
                    ? excelLocalizedDateFormat(cell.value, accountTagFormat)
                    : excelLocalizedNumberFormat(cell.value, accountTagFormat)
                : getNumValue(cell.value, numformat, kpiLineFormat);
    }
    return (React.createElement(KPIRowCell, null,
        cf > 0 && cell && cell.value !== null && (React.createElement(ConditionalFormattingComponent, { value: cell.value, cfData: column, cfValueTypeValue: ConditionalFormattingValueType.GOOD })),
        !hideNumbers && (React.createElement("div", { style: { paddingRight: padd ? 20 : 0, position: 'relative' } },
            React.createElement(Transition, { text: formattedValue })))));
}
function Transition(props) {
    var prevTextRef = React.useRef(props.text);
    React.useEffect(function () {
        prevTextRef.current = props.text;
    });
    var prevText = prevTextRef.current;
    var currText = props.text;
    if (prevText !== currText) {
        return (React.createElement(Spring, { from: { color: 'red', textShadow: '0px 0px 1px rgba(255,0,0,1.0)' }, to: { color: appColors.ui.dark, textShadow: '0px 0px 0px rgba(0,0,0,0.0)' }, config: { duration: 1000 } }, function (props) { return React.createElement("div", { style: props }, currText); }));
    }
    return React.createElement("div", null, props.text);
}
function getNumValue(val, widgetFormat, kpiLineFormat) {
    if (kpiLineFormat === KpiLineFormat.PERCENT_2DECIMALS || kpiLineFormat === KpiLineFormat.PERCENT_WHOLE) {
        return formatNumberKPI(val, kpiLineFormat);
    }
    else {
        return formatNumber(val, widgetFormat);
    }
}
function ConditionalFormattingComponent(props) {
    var value = props.value, cfData = props.cfData, _a = props.cfValueTypeValue, cfValueTypeValue = _a === void 0 ? ConditionalFormattingValueType.GOOD : _a;
    var min = cfData.conditionalFormattingType === ConditionalFormattingType.RELATIVE && cfData.colMin ? cfData.colMin : 0;
    var max = cfData.conditionalFormattingType === ConditionalFormattingType.RELATIVE && cfData.colMax ? cfData.colMax : 100;
    var percent, color;
    switch (cfData.conditionalFormatting) {
        case ConditionalFormatting.TRAFFIC:
            percent = Math.min(((value - min) / (max - min)) * 100, 100);
            if (percent < 33) {
                color = '#fe0605';
            }
            else if (percent < 67) {
                color = '#fac50d';
            }
            else {
                color = '#8cb302';
            }
            return (React.createElement(TrafficLights, null,
                React.createElement(TrafficLightsInner, { style: { backgroundColor: color } })));
        case ConditionalFormatting.DATABAR:
            percent = Math.min((value / max) * 100, 100);
            if (percent < 0) {
                percent = 0;
            }
            return (React.createElement(DataBar, null,
                React.createElement(DataBarInner, { style: { width: percent + '%' } })));
        case ConditionalFormatting.COLORSCALE:
            percent = Math.min(((value - min) / (max - min)) * 100, 100);
            color = colorGradient(percent / 100);
            return (React.createElement(ColorScale, null,
                React.createElement(ColorScaleInner, { style: { backgroundColor: color } })));
        case ConditionalFormatting.ARROWS:
            if (cfValueTypeValue === ConditionalFormattingValueType.OFF) {
                return null;
            }
            var conditional1 = cfValueTypeValue === ConditionalFormattingValueType.GOOD ? value > 0 : value < 0;
            var conditional2 = cfValueTypeValue === ConditionalFormattingValueType.GOOD ? value < 0 : value > 0;
            if (conditional1) {
                return React.createElement(Arrows, { "$color": "#8cb302" }, "\u25B2");
            }
            else if (conditional2) {
                return React.createElement(Arrows, { "$color": "#fe0605" }, "\u25BC");
            }
        default:
            return null;
    }
}
function colorGradient(fadeFraction) {
    var rgbColor1 = { red: 248, green: 105, blue: 107 }; // red
    var rgbColor2 = { red: 250, green: 197, blue: 13 }; // yellow
    var rgbColor3 = { red: 140, green: 179, blue: 2 }; // green
    var color1 = rgbColor1;
    var color2 = rgbColor2;
    var fade = fadeFraction;
    // Do we have 3 colors for the gradient? Need to adjust the params.
    if (rgbColor3) {
        fade = fade * 2;
        // Find which interval to use and adjust the fade percentage
        if (fade >= 1) {
            fade -= 1;
            color1 = rgbColor2;
            color2 = rgbColor3;
        }
    }
    var diffRed = color2.red - color1.red;
    var diffGreen = color2.green - color1.green;
    var diffBlue = color2.blue - color1.blue;
    var gradient = {
        red: Math.floor(color1.red + diffRed * fade),
        green: Math.floor(color1.green + diffGreen * fade),
        blue: Math.floor(color1.blue + diffBlue * fade),
    };
    return 'rgb(' + gradient.red + ',' + gradient.green + ',' + gradient.blue + ')';
}
export default KPI;
